import configRaw from 'webappConfig';

/////////////////////////////////////////
import { isDevSsoAttempt } from 'utils/devSso/capture';
/////////

let skipDevDomainRegistration = false;
/////////////////////////////////////////
skipDevDomainRegistration = isDevSsoAttempt();
/////////

const selfOrWindow =
  typeof window !== 'undefined'
    ? window
    : typeof self !== 'undefined'
      ? self
      : typeof global !== 'undefined'
        ? global
        : {};
export const HOSTNAME = selfOrWindow.location?.hostname;
export const PORT = selfOrWindow.location?.port;
export const PROTOCOL = selfOrWindow.location?.protocol || 'http:';

// DEV ONLY — eliminated from production bundles as dead code.
// Register this port with the redirect stub via a hidden iframe so the write
// lands in localhost:3000's localStorage (same-origin with the stub). Re-runs
// whenever the tab becomes visible, so switching browser tabs is all it takes
// to switch which dev server receives the next OAuth callback.
if (
  process.env.NODE_ENV !== 'production' &&
  !skipDevDomainRegistration &&
  PORT &&
  !(HOSTNAME === 'localhost' && PORT === '3000') &&
  typeof document !== 'undefined'
) {
  const registerDevDomain = () => {
    try {
      const devDomain = encodeURIComponent(`${PROTOCOL}//${HOSTNAME}${PORT ? `:${PORT}` : ''}`);
      const iframe = document.createElement('iframe');
      iframe.src = `http://localhost:3000/set-devdomain?domain=${devDomain}`;
      iframe.style.cssText = 'display:none';
      document.body.appendChild(iframe);
      setTimeout(() => iframe.remove(), 3000);
    } catch (_) {
      // ignore — stub may not be running
    }
  };

  registerDevDomain();
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      registerDevDomain();
    }
  });
}

let configuredEnvironment =
  (['localhost', 'machost'].includes(HOSTNAME)
    ? process.env.SERVICE_ENV
    : HOSTNAME && configRaw.hosts[HOSTNAME]?.environment_default) || 'stg';
/////////////////////////////////////////
// IP and static preview hosts have no host entry. Honor the existing build environment, including clean reloads.
if (HOSTNAME && !configRaw.hosts[HOSTNAME]) configuredEnvironment = process.env.SERVICE_ENV || 'stg';
/////////
export const ENVIRONMENT = configuredEnvironment;
export const BUILD_TYPE =
  (HOSTNAME && configRaw.hosts[HOSTNAME]?.build_override) || process.env.NODE_ENV || 'development';

function processConfig(config) {
  const newConfig = {};
  Object.keys(config).forEach((key) => {
    let keyObj;
    if (typeof config[key] === 'object' && !Array.isArray(config[key])) {
      keyObj = processConfig(config[key]);
    } else {
      keyObj = typeof config[key] === 'string' ? config[key].replace('ENV_PORT', PORT) : config[key];
    }
    newConfig[key] = keyObj;
  });

  return newConfig;
}

export const Config = processConfig(configRaw);
